<header *ngIf="!showCropper">
  <app-generic-header *ngIf="this.userData?.interest2!=null" [goBack]=backPage.bind(this) variant="save"
    [title]="'profile'| translate"></app-generic-header>
</header>

<ion-content class="ion-padding" [class.ipad-fix]="isIpad" [class.tablet-fix]="isTablet">

  <app-generic-header *ngIf="showCropper" [goBack]=back.bind(this) variant="back"
    [title]="'profile'| translate"></app-generic-header>

  <div class="cover" *ngIf="!activeFocus">
    <br>
  </div>

  <div>
    <div class="frameDiv">
      <div class="mainDiv" [class.ipad-main-div]="isIpad" [class.tablet-main-div]="isTablet">
        <h2 *ngIf="isFirstSetup" class="welcomeText">
          {{'welcomeToVeggly' | translate}}
        </h2>

        <p *ngIf="isFirstSetup" class="pleaseCompleteText">{{'pleaseCompleteYourProfile' | translate}}</p>

        <ion-row class="box-photos">
          <ion-col size="6">
            <div class="infoCategoryText photos">
              {{'myPictures' | translate}}
            </div>
          </ion-col>
        </ion-row>

        <!--Photo Grid-->
        <div class="boxes" [ngClass]="{'shuffling-active': shuffling}">
          <div *ngIf="showCropper">
            <div class="block-cropper">
              <angular-cropper #angularCropper [cropperOptions]="cropperOptions" [imageUrl]="myImage"></angular-cropper>
            </div>
          </div>

          <!-- Photo Grid - Normal Mode-->
          <div *ngIf="!shuffling && !showCropper">
            <div class="horizontalList" (press)="startShuffle()" *ngFor="let picture of pictures; let i = index">
              <div class="img-wrapper">
                <img class="boxImg" [src]="picture" (click)="presentActionSheet(i)"
                  (dragstart)="$event.preventDefault()" draggable="false" />

                <!-- Exclude image icon -->
                <div *ngIf="picture!=grayPlus" (click)="presentActionSheet(i)" class="close-circle">
                  <ion-icon name="close"></ion-icon>
                </div>

                <div *ngIf="picture!=grayPlus && i===0 && userData?.userValidated" class="logoUserValidated">
                  <ion-icon src="assets/imgs/new-check-img.svg" alt="Validated Imge"></ion-icon>
                </div>

              </div>
            </div>
          </div>

          <!-- Shuffling Mode -->
          <div *ngIf="shuffling && !showCropper" [nxtSortablejs]="pictures">
            <div class="horizontalList" *ngFor="let picture of pictures; let i = index" [attr.data-id]="i">
              <img [ngClass]="{'shake': i !== 0 && userData?.userValidated || !userData?.userValidated}" class="boxImg"
                [src]="picture" />

              <!-- Validated user -->
              <img *ngIf="picture!=grayPlus && i===0 && userData?.userValidated" class="logoUserValidated"
                src="assets/imgs/new-check-img.svg" alt="Validated Image">
            </div>
          </div>

          <div class="saveOrder">
            <ion-button *ngIf="!showCropper && shuffling" shape="round" expand="full" (click)="saveOrder()">
              <ion-icon class="buttonIcon" name="reorder-four-outline"></ion-icon>
              {{('saveOrder') | translate}}
            </ion-button>
          </div>

        </div>

        <div class="pictureTip" *ngIf="!showCropper">
          {{'pressHoldToReorder' | translate}}
        </div>

        <div id="userInfoContainer" *ngIf="!showCropper">
          <div class="abouteMe">
            <span class="infoCategoryText">{{'aboutMe' | translate}}</span>

            <ion-list lines="none">

              <ion-item>
                <ion-textarea (ionChange)="setChanged()" [(ngModel)]="aboutData" lines="none"
                  class="selectText"></ion-textarea>
              </ion-item>

              <ion-item>
                <div class="charsRemaining">
                  <span class="charsLeft{{getCharStatus()}}">{{getCharsLeft()}} {{'left' | translate}}</span>
                </div>
              </ion-item>
            </ion-list>

          </div>
          <span class="infoCategoryText">{{'aboutMe' | translate}}</span>
          <!---Avocai Club Indicator-->
          <div [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="!userIsPremium && goToAvocadoClubIndicator()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/flamrplus.svg">
              {{'showAvocadoClubInProfile' | translate}}

            </div>

            <div class="avocadoToggle">
              <ion-toggle mode="md" [ngModel]="showAvocadoClubIndicator" (ngModelChange)="setShowAvocadoClubIndicator()"
                disabled="{{!userIsPremium}}"></ion-toggle>
            </div>
          </div>

          <div *ngIf="!userData?.userValidated" [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="openValidation()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/new-check-img.svg">
              {{'validateProfile' | translate}}
            </div>

            <div class="categoryArrow">
              <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
            </div>

          </div>


          <div *ngIf="userData?.userValidated" [ngStyle]="(!userIsPremium ? {'cursor': 'pointer'} : null)"
            (click)="openValidation()" class="avocadoButton">

            <div class="avocadoText">
              <img class="avocado" src="assets/imgs/new-check-img.svg">
              {{'validatedProfile' | translate}}
            </div>

            <div class="categoryArrow">
              <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
            </div>

          </div>

          <!--Green Buttons-->
          <div class="essentialMyInfoButtons">

            <span class="infoCategoryText">{{'myInfo' | translate}}</span>

            <!-- Diet -->
            <!-- <app-info-button (click)="setPageInfo('diet')" [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/diet.svg'" [tittle]="'dietLifestyle' | translate" [info]="userData != null ? (userData?.diet | translate) : ''" [fill] = "'solid'"></app-info-button> -->

            <!--Gender-->
            <app-info-button (click)="setPageInfo('gender')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/gender.svg'" [tittle]="'gender' | translate" [info]="
            (userData?.gender2 != null ? getGenderDisplayText(userData?.gender2) : '') +
            (userData?.gender2 === 'other' && userData?.genderdescription ? ' - ' + userData?.genderdescription : '')"
              [fill]="'solid'"></app-info-button>

            <!-- Interese-->
            <app-info-button (click)="setPageInfo('interest')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/heart.svg'" [tittle]="'interestedIn' | translate"
              [info]="userData != null ? interestOptions() : ''" [fill]="'solid'"></app-info-button>

            <!-- Name-->
            <app-info-button (click)="setPageInfo('name')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/name.svg'" [tittle]="'name' | translate"
              [info]="userData != null ? userData?.firstName : ''" [fill]="'solid'"></app-info-button>

            <!--Age-->
            <app-info-button (click)="setPageInfo('age')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/age.svg'" [tittle]="'age' | translate"
              [info]="userData != null ? userData?.age : ''" [fill]="'solid'"></app-info-button>

            <!---City-->
            <app-info-button (click)="setPageInfo('city')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/location.svg'" [tittle]="'city' | translate"
              [info]="userData != null ? userData?.city : ''" [fill]="'solid'"></app-info-button>

            <!---Referral Email-->
            <app-info-button *ngIf="this.isFirstSetup" (click)="setPageInfo('referralEmail')"
              [iconPath]="'/assets/imgs/logo.svg'" [tittle]="'referralEmail' | translate"
              [info]="userData != null ? userData?.referralEmail : ''" [fill]="'solid'"></app-info-button>

          </div>

          <div class="socialCausesContainer">
            <span class="socialCausesLabel">{{'socialCauses' | translate}}</span>
            <ion-item class="socialCausesItem" (click)="setPageInfo('socialCauses')">
              <div class="socialCausesContent">
                <div class="socialCausesValue">
                  <div *ngFor="let cause of userData?.socialCauses" class="socialCauseCard">
                    {{getSocialCauseDisplayText(cause)}}
                  </div>
                </div>
                <div class="categoryArrow">
                  <ion-icon src="/assets/imgs/custom-svg/Icon akar-arrow-left.svg"></ion-icon>
                </div>
              </div>
            </ion-item>
          </div>


          <div class="extraMyInfoButtons">
            <span class="infoCategoryText">{{'moreDetails' | translate}}</span>



            <!-- Activism-->
            <app-info-button (click)="setPageInfo('activism')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/activism.svg'" [tittle]="'activism' | translate"
              [info]="userData && userData?.activism != null ? (userData?.activism | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!--Work-->
            <app-info-button (click)="setPageInfo('work')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/work.svg'" [tittle]="'workTitle' | translate"
              [info]="userData && userData?.work != null ? userData?.work : ''" [fill]="'outline'"></app-info-button>

            <!--Education-->
            <app-info-button (click)="setPageInfo('education')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/education.svg'" [tittle]="'education' | translate"
              [info]="userData && userData?.education != null ? (userData?.education | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Height-->
            <app-info-button (click)="setPageInfo('height')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/height.svg'" [tittle]="'height' | translate"
              [info]="userData != null && userData?.height != null ? setHeight() : ''"
              [fill]="'outline'"></app-info-button>

            <!---Physical Exercise-->
            <app-info-button (click)="setPageInfo('exercise')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/physicalExercise.svg'"
              [tittle]="'physicalExercise' | translate"
              [info]="userData && userData?.exercise != null ? (userData?.exercise | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Looking For-->
            <app-info-button (click)="setPageInfo('lookingFor')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/lookingFor.svg'" [tittle]="'lookingFor' | translate"
              [info]="userData && userData?.lookingFor != null ? lookingForOptions() : ''"
              [fill]="'outline'"></app-info-button>

            <!---Children-->
            <app-info-button (click)="setPageInfo('children')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/children.svg'" [tittle]="'children' | translate"
              [info]="userData && userData?.children != null ? (userData?.children | translate) : ''"
              [fill]="'outline'"></app-info-button>

            <!---Astrology Sign-->
            <app-info-button (click)="setPageInfo('astroSign')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/astrology.svg'"
              [tittle]="'astrologySign' | translate" [info]="userData != null ? userData?.astrologySign : ''"
              [fill]="'outline'"></app-info-button>

            <!---Religion-->
            <app-info-button (click)="setPageInfo('religion')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/religion.svg'" [tittle]="'religion' | translate"
              [info]="userData != null ? userData?.religion : ''" [fill]="'outline'"></app-info-button>

            <!---Politics-->
            <app-info-button (click)="setPageInfo('politics')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/politics.svg'" [tittle]="'politics' | translate"
              [info]="userData != null ? userData?.politics : ''" [fill]="'outline'"></app-info-button>

            <!---Animals-->
            <app-info-button (click)="setPageInfo('pets')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/animal_new.svg'" [tittle]="'animals' | translate"
              [info]="userData != null ? userData?.pets : ''" [fill]="'outline'"></app-info-button>

          </div>


          <!--Grey Buttons-->
          <div class="distanceUnitButton">

            <!--Distance Units-->
            <app-info-button (click)="setPageInfo('distanceUnits')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/distance.svg'"
              [tittle]="'distanceUnits' | translate"
              [info]="userData && userData?.distanceUnit != null ? (userData?.distanceUnit | translate) : ''"
              [fill]="'gray'"></app-info-button>

            <!--Language-->
            <app-info-button (click)="setPageInfo('language')"
              [iconPath]="'/assets/imgs/custom-svg/padronized-sizes/language.svg'" [tittle]="'language' | translate"
              [info]="userData && userData?.language != null ? (userData?.language | translate) : ''"
              [fill]="'gray'"></app-info-button>


            <div *ngIf="this.userData?.interest2!=null" class="save-button">
              <ion-button shape="round" expand="full" color="primary" (click)="backPage()" block>{{'save' |
                translate}}</ion-button>
            </div>

          </div>

        </div>

      </div>
    </div>
  </div>


</ion-content>
<ion-footer>
  <ion-grid class="box-crop-options" *ngIf="showCropper">
    <ion-row *ngIf="showCropper">
      <ion-col size="6">
        <ion-button expand="full" shape="round" (click)="reset()" fill="outline">{{'discard' | translate}}</ion-button>
      </ion-col>

      <ion-col size="6">
        <ion-button expand="full" shape="round" (click)="saveCropped()">{{'save' | translate}}</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>